// Access check (SPEC §3): GET /repos/{owner}/{repo}. 404 or no push → No access.
// A 404 can also mean the GitHub App isn't installed on the repo (spike tests 1/6).
import type { GitHub } from './client';

export type Viewer = { login: string; name: string | null };
export type Access =
  | { kind: 'ok'; viewer: Viewer }
  | { kind: 'no-access'; viewer: Viewer; reason: 'not-found' | 'read-only' };

type RepoResponse = { permissions?: { push?: boolean } };

export async function checkAccess(gh: GitHub, repo: { owner: string; name: string }): Promise<Access> {
  const [viewer, r] = await Promise.all([
    gh.rest<Viewer>('/user'),
    gh.rest<RepoResponse>(`/repos/${encodeURIComponent(repo.owner)}/${encodeURIComponent(repo.name)}`),
  ]);
  if (!viewer) throw new Error('GET /user returned 404');
  const v = { login: viewer.login, name: viewer.name };
  if (!r) return { kind: 'no-access', viewer: v, reason: 'not-found' };
  if (r.permissions?.push !== true) return { kind: 'no-access', viewer: v, reason: 'read-only' };
  return { kind: 'ok', viewer: v };
}
